var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatusCompleted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2",
    transform: "translate(0.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1",
    transform: "translate(-0.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    d: "M13.99,0a14,14,0,1,0,14,13.981A14,14,0,0,0,13.99,0Zm9.135,9.806L12.477,20.454a.689.689,0,0,1-.958,0L6.789,15.7a.651.651,0,0,1,0-.938.689.689,0,0,1,.938,0L12,19.037,22.187,8.848a.689.689,0,0,1,.938,0,.67.67,0,0,1,0,.958Z",
    transform: "translate(0.01)",
    fill: "#69f5d5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusCompleted);
export default __webpack_public_path__ + "static/media/StatusCompleted.0f943ede.svg";
export { ForwardRef as ReactComponent };